<template lang="pug">
article.current-project
  .current-slideshow
    transition-group(:name="transition")
      .slide(v-for="(slide, index) in slides", :key="index", v-show="current === index")
        header(v-if='slide.gray_slide').grey-slide
          .bar.serif(v-if='slide.caption.length && slide.caption[0].text') <span v-html="slide.caption[0].text"></span>
        figure(v-else)
          div(@mouseenter="imgHover", @mouseleave="imgHover(false)", :class="{'diptych': !empty(slide.image_2)}")
            img(v-if="!empty(slide.image_1)", :src="imgSrc(slide.image_1.url, isPortrait(slide.image_1))", :data-portrait="isPortrait(slide.image_1)")
            img(v-if="!empty(slide.image_2)", :src="imgSrc(slide.image_2.url, isPortrait(slide.image_2))", :data-portrait="isPortrait(slide.image_2)")
</template>

<script>
import Vue from 'vue'
import _isEmpty from 'lodash/isEmpty'
const Modernizr = window.Modernizr

export default {
  name: 'CurrentProject',
  props: ['title', 'current', 'slides', 'transition'],
  inheritAttrs: false,
  data () {
    return {
      winW: window.innerWidth
    }
  },
  methods: {
    empty (value) {
      return _isEmpty(value)
    },
    // cloudinary resize function?
    // imgSrc (src, portrait = false) {
    //   if (!src) return ''
    //   let t = portrait ? 'w_400' : 'w_800' // mobile (based on width)
    //   t = this.winW > 600 ? 'h_800' : t // tablet / laptop
    //   t = this.winW > 1280 ? 'h_1280' : t // large
    //   return Vue.config.IMGS.BASE + '/image/fetch/' + t + '/' + src
    // },
    imgSrc (src, portrait = false) {
      if (!src) return ''
      let t = portrait ? 'w=800' : 'w=1600' // mobile (based on width)
      t = this.winW > 600 ? 'h=1600' : t // tablet / laptop
      t = this.winW > 1280 ? 'h=2560' : t // large
      return src + '&' + t
    },
    imgHover (entered = true) {
      console.log('imgHover')
      if (!Modernizr.touchevents) {
        if (entered) return this.$emit('imgHover')
        return this.$emit('imgLeave')
      }
    },
    isPortrait (img) {
      return img ? img.dimensions.width < img.dimensions.height : false
    }
  }
}
</script>

<style lang="scss">
@import '../style/variables';

/* @include onMobile() {
  .grey-slide {
    position: relative;
    transform: translateY(-1rem);
    z-index: 999;
  }
} */

/* .current-slideshow .slide { */
  
  /* transition-property: transform; */
  /* transition-duration: $trans-slideX; */
  /* figure {
    padding: 0 !important;
  } */
  /* opacity: 0.5; */
/* } */

.current-project{
  width:100%;
  height:100vh;
  height: calc(var(--vh, 1vh) * 100);
  overflow:hidden;

  img{
    min-width:100px;
    min-height:100px;
  }

  header{
    background-color:$color-bg;
  }

  .bar{
    position: absolute;
    background:transparent;
  }

  .preload{
    display:none;
  }

  .current-slideshow{
    position: relative;
    width:100%;
    height:100vh;
    height: calc(var(--vh, 1vh) * 100);
    outline:2px solid transparent;
    
    @include onMobile () {
      header .bar {
        /* background: red; */
        /* height: 20vh;  */
      }
    }
    
    .slide {
      .grey-slide {
        width: 100vw;
      }
      /* @include background(absolute); // oddly helps ios render sliding from off-screen :(
      outline:2px solid transparent;
      > * {
        @include background(absolute); // oddly helps ios render sliding from off-screen :(
      } */
      /* background: pink; */
      /* position:$pos; */
      /* top:0;
      left:0;
      width:100%;
      height:100%; */
      /* transition-property: transform; */
      /* transition-duration: $trans-slideX; */
      /* transition-timing-function: ease; */
      will-change: transform;
      width: 100vw;
      height: 100vh;
      height: calc(var(--vh, 1vh) * 100);
      position: absolute;
      transition-property: transform;
      transition-duration: $trans-slideX;
      /* transition-duration: 3s; */
      /* transition-timing-function: linear; */
      /* display: none;
      &.visible {
        display: block;
      } */
      figure{
        height: 100vh;
        width: 100vw;
        height: calc(var(--vh, 1vh) * 100);
        display:flex;
        align-items:center;
        justify-content: center;
        padding:0 em(40px);
        
        div {
          display:flex;
          align-items: center;
          justify-content: space-between;
          // new
          img {
            max-width: 100vw;
            max-height: (638px/$doc-h)*100vh; // (512px/$doc-h)*100vh;
          }
          // old
          /* img{
            max-width:none;
            max-height: (538px/$doc-h)*100vh; // (512px/$doc-h)*100vh;
          } */
        }

        .diptych{
          img + img{
            margin-left:rem(40px);
          }
          // new
          img{
            max-width:none;
            max-height: (638px/$doc-h)*100vh;
          }
          // old
          /* img {
            max-width:none;
            max-height: (538px/$doc-h)*100vh; // (512px/$doc-h)*100vh;
          } */
        }
        
        // Portrait

        @media (orientation:portrait) {

          div{
            img:not([data-portrait]){
              max-width:100%;
              max-height:none;
            }
          }

          .diptych{
            img{
              max-width:calc(50% - #{rem(20px)};
              & + img{ 
                margin:0; 
              }
            }
          }
          
          // Portrait - Mobile

          @include onMobile () {

            // figure
            padding:0 rem(20px);

            div{
              img{
                max-width:100%;
                max-height:none;
              }
            }

            .diptych{
              img{
                max-width:calc(50% - #{rem(10px)});
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// CurrentProject.vue?11cc32f9